export const sortClubsByLoft = <T extends { loftDigit?: string | null; loftFraction?: string | null }>(a: T, b: T): number => {
  const hasLoftA = a?.loftDigit !== '';
  const hasLoftB = b?.loftDigit !== '';

  // Prioritize clubs with lofts first
  if (hasLoftA && !hasLoftB) return -1;
  if (!hasLoftA && hasLoftB) return 1;

  // If both missing or both have lofts, compare numerically
  const loftA = hasLoftA ? parseFloat(a.loftDigit!) + parseFloat(a.loftFraction ?? '0') : Number.POSITIVE_INFINITY; // push missing lofts down

  const loftB = hasLoftB ? parseFloat(b.loftDigit!) + parseFloat(b.loftFraction ?? '0') : Number.POSITIVE_INFINITY;

  return loftA - loftB;
};
